import React from "react";
import {FormControl, InputLabel, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {css} from "@emotion/css";

const HeaderStyleDropdown = (props) => {

    const onToggle = (event) => {
        let value = event.target.value;
        props.onToggle(value);
    };

    return (
        /*<div className={css`
        width: 150px !important;        
        `}>
            <FormControl fullWidth>
                <InputLabel>تگ</InputLabel>
                <Select
                    value={props.active}
                    onChange={onToggle}
                    label=" تگ "
                >
                    {props.headerOptions.map(heading => {
                        return  <MenuItem value={heading.style}>{heading.label}</MenuItem>
                    })}
                </Select>
            </FormControl>
        </div>*/
        <select value={props.active} onChange={onToggle} className={"textEditorTextTagSelect"}>
            <option value="">Header Levels</option>
            {props.headerOptions.map(heading => {
                return <option value={heading.style}>{heading.label}</option>;
            })}
        </select>
    );

}


export default HeaderStyleDropdown;